import { Component } from 'react'
import update from 'immutability-helper'
import { DndProvider } from 'react-dnd'
import Backend from 'react-dnd-html5-backend'
import ReorderListItem from './ReorderListItem'
import { List } from '@material-ui/core'
import PropTypes from 'prop-types'

class ReorderList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      items: this.props.itemsFromParent,
      itemsError: this.itemsValidation(this.props.itemsFromParent),
      hidePhone: this.props.hidePhoneFromParent,
    }

    this.handleOnClick = this.handleOnClick.bind(this)
    this.moveListItem = this.moveListItem.bind(this)
  }

  itemsValidation(items) {
    // loop through the json list, and if any are true, return true, or else return false
    var returnVar = false
    items.map((item, i) => (returnVar = item.checked ? true : !!returnVar))
    // console.log(returnVar)
    return returnVar
  }

  handleOnClick(item) {
    // You may pass handle on click event to props

    if (item.checked) {
      item.checked = false
    } else {
      item.checked = true
    }
    // console.log(item);
    this.setState(this.state.items)
    this.setState({
      itemsError: this.itemsValidation(this.state.items),
    })
    this.props.callbackFromParentContactMethodValid(
      this.itemsValidation(this.state.items),
    )
  }

  moveListItem(dragIndex, hoverIndex) {
    const { items } = this.state
    const dragitem = items[dragIndex]

    this.setState(
      update(this.state, {
        items: {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragitem],
          ],
        },
      }),
    )
    // You may pass the state to props
    // console.log(this.state.items);
    this.props.callbackFromParentContactMethodList(this.state.items)
  }

  itemsToRender(item, i) {
    let returnItem = ''

    if (item.text === 'Phone' && this.state.hidePhone) {
      // skip over record
    } else {
      returnItem = (
        <ReorderListItem
          key={item.id}
          handleOnClick={() => this.handleOnClick(item)}
          index={i}
          id={item.id}
          text={item.text}
          moveListItem={this.moveListItem}
          checked={item.checked}
        />
      )
    }
    return returnItem
  }
  render() {
    const { items } = this.state

    return (
      <div>
        <DndProvider backend={Backend}>
          <List className={this.props.className}>
            {items.map((item, i) => this.itemsToRender(item, i))}
          </List>
        </DndProvider>
      </div>
    )
  }
}

export default ReorderList

ReorderList.propTypes = {
  className: PropTypes.string.isRequired,
  hidePhoneFromParent: PropTypes.bool.isRequired,
  callbackFromParentContactMethodValid: PropTypes.func.isRequired,
  itemsFromParent: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
      checked: PropTypes.bool.isRequired,
    }),
  ),
  callbackFromParentContactMethodList: PropTypes.func.isRequired,
}
